<!--US Page-->
<div class="dtfglossary" >
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


    <!--Banner-->
    <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Calculator_Header_Image.jpg);">
      <section class="mbfs-home-hero__header">
       <h2 id="scrollpoint" class="mbfs-home-hero__header-subtitle">
        {{ 'Calculator.Header' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi" style="text-align:center;">
          {{ 'Calculator.SubHeader' | translate }}
        </p>
      </section>
    </section>

    <div class="container">
      <a id="mbfs-header-login-cta" id="auto_triggercalculator" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickCalculator($event)" hidden></a>
    <br><br>
      <div class="shortrow">
        <mat-accordion class="example-headers-align" multi>
          <!-- #enddocregion multi -->
          <mat-expansion-panel>
            <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
              <mat-panel-title style="gap: 10px;">
                <b>{{'Calculator.AffordabilityCalculator' | translate }}</b>
                <table>
                  <tr>
                    <td>{{ 'Calculator.AffordabilityText' | translate }}</td>
                  </tr>
                </table>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="calculatorForm" *ngIf="openLoginModal">
                <div class="shortrow">
                  <div class="form-group">
                    <label class ="inputlabel" for="desiredMonthlyPayment"><b style="color:#00566A;">{{ 'Calculator.DesiredMonthly' | translate }}*</b></label>
                    <p>{{ 'Calculator.DesiredMonthlyText' | translate }}</p>
                 </div>
                 <div class="form-group">
                  <div class="dollar">
                    <input  type="number" class="form-control" formControlName="desiredMonthlyPayment" [(ngModel)]="desiredMonthlyPayment" required validateonblur value=""      
                    placeholder= " " id="desiredMonthlyPayment"  name="desiredMonthlyPayment" min="0">
                  </div>
                 </div>
              </div>
              <div class="shortrow">
                <div class="form-group">
                  <label class ="inputlabel" for="downPayment"><b style="color:#00566A;">{{ 'Calculator.DownPayment' | translate }}*</b></label>
                  <p>{{ 'Calculator.DownPaymentText' | translate }}</p>
               </div>
               <div class="form-group">
                <div class="dollar">
                  <input type="number" class="form-control" formControlName="downPayment" [(ngModel)]="downPayment" required validateonblur value=""
                  placeholder= " " id="downPayment"  name="downPayment" min="0">
                </div>
               </div>
            </div>
            <div class="shortrow">
              <div class="form-group">
                <label class ="inputlabel" for="salesTaxRate"><b style="color:#00566A;">{{ 'Calculator.SalesTax' | translate }}*</b></label>
                <p>{{ 'Calculator.SalesTaxText' | translate }}</p>
             </div>
             <div class="form-group">
              <div class="percent">
                <input type="number" class="form-control" formControlName="salesTaxRate" [(ngModel)]="salesTaxRate" required validateonblur value=""
                placeholder= " " id="salesTaxRate"  name="salesTaxRate" min="0">
              </div>
             </div>
          </div>
          <div class="shortrow">
            <div class="form-group">
              <label class ="inputlabel" for="interestRate"><b style="color:#00566A;">{{ 'Calculator.InterestRate' | translate }}*</b></label>
              <p>{{ 'Calculator.InterestRateText' | translate }}</p>
           </div>
           <div class="form-group">
            <div class="percent">
              <input  type="number" class="form-control"  formControlName="interestRate" [(ngModel)]="interestRate" required validateonblur value=""
              placeholder= " " id="interestRate"  name="interestRate" min="0">
            </div>
           </div>
        </div>
        <div class="shortrow">
          <div class="form-group">
            <label class ="inputlabel" for="financingPeriod"><b style="color:#00566A;">{{ 'Calculator.FinancingTerm' | translate }}*</b></label>
            <p>{{ 'Calculator.FinancingTermText' | translate }}</p>
         </div>
         <div class="form-group">
           <div class="month">
            <select class="form-control" formControlName="financingPeriod" [(ngModel)]="financingPeriod" required
              id="financingPeriod" name="financingPeriod" style="width: 214px; border-color: black; border-width: thin;">
              <option *ngFor="let period of [12, 24, 36, 48, 72]" [value]="period">{{ period }}</option>
            </select>
            </div>
         </div>
      </div>
      <div style="text-align: center;">
        <button type="submit" name="submit" [disabled]="!this.tableLoaded" (click)="getCalculator('afford')" class="mbfs-button">{{ 'Calculator.Calculate' | translate }}</button>
        <button type="submit" name="submit" (click)="clearCalculator()" class="mbfs-button">{{ 'Calculator.Clear' | translate }}</button>
        <br><br>
      </div>
      <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
        <!--Spinner on Login Load-->
        <div class="demo-container">
          <span>{{ 'Invoice.Loading' | translate }}</span>
          <div class="progress-bar">
            <div class="progress-bar-value"></div>
          </div>
        </div>
        <br>
      </div>

      <div class="shortrow" *ngIf="ShowMaxCost">
        <div class="form-group">
          <label class ="inputlabel" for="maxCost"><b style="color:#00566A;">{{ 'Calculator.ApproxLoan' | translate }}</b></label>
       </div>
       <div class="form-group">
        <div class="dollar">
          <input type="number" class="form-control" disabled validateonblur value="{{this.maxCost}}"
          placeholder= " " id="maxCost"  name="maxCost"  >
        </div>
       </div>
    </div>
           </form>
  </mat-expansion-panel>
        </mat-accordion>
      
        <mat-accordion class="example-headers-align" multi>
          <!-- #enddocregion multi -->
          <mat-expansion-panel>
            <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
              <mat-panel-title style="gap: 10px;">
                <b>{{ 'Calculator.PaymentCalculator' | translate }}</b>
                <table>
                  <tr>
                    <td>{{ 'Calculator.PaymentCalculatorText' | translate }}</td>
                  </tr>
                </table>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="calculatorForm" *ngIf="openLoginModal">
            <div class="shortrow">
              <div class="form-group">
                <label class ="inputlabel" for="salesPrice"><b style="color:#00566A;">{{ 'Calculator.TruckSalesPrice' | translate }}*</b></label>
                <p>{{ 'Calculator.TruckSalesPriceText' | translate }}</p>
             </div>
             <div class="form-group">
              <div class="dollar">
                <input  type="number" class="form-control" formControlName="salesPrice"  [(ngModel)]="salesPrice" required validateonblur value=""
                placeholder= " " id="salesPrice"  name="salesPrice"  min="0">
              </div>
             </div>
          </div>
          <div class="shortrow">
            <div class="form-group">
              <label class ="inputlabel" for="downPayment"><b style="color:#00566A;">{{ 'Calculator.DownPayment' | translate }}*</b></label>
              <p>{{ 'Calculator.DownPaymentText' | translate }}</p>
           </div>
           <div class="form-group">
            <div class="dollar">
              <input  type="number" class="form-control" formControlName="downPayment" [(ngModel)]="downPayment" required validateonblur value=""
              placeholder= " " id="downPayment"  name="downPayment"  min="0">
            </div>
           </div>
        </div>
        <div class="shortrow">
          <div class="form-group">
            <label class ="inputlabel" for="salesTaxRate"><b style="color:#00566A;">{{ 'Calculator.SalesTax' | translate }}*</b></label>
            <p>{{ 'Calculator.SalesTaxText' | translate }}</p>
         </div>
         <div class="form-group">
          <div class="percent">
            <input type="number" class="form-control" formControlName="salesTaxRate" [(ngModel)]="salesTaxRate" required validateonblur value=""
            placeholder= " " id="salesTaxRate"  name="salesTaxRate" min="0">
          </div>
         </div>
      </div>
      <div class="shortrow">
        <div class="form-group">
          <label class ="inputlabel" for="interestRate"><b style="color:#00566A;">{{ 'Calculator.InterestRate' | translate }}*</b></label>
          <p>{{ 'Calculator.InterestRateText' | translate }}</p>
       </div>
       <div class="form-group">
        <div class="percent">
          <input type="number" class="form-control" formControlName="interestRate" [(ngModel)]="interestRate" required validateonblur value=""
          placeholder= " " id="interestRate"  name="interestRate" min="0">
        </div>
       </div>
    </div>
    <div class="shortrow">
      <div class="form-group">
        <label class ="inputlabel" for="financingPeriod"><b style="color:#00566A;">{{ 'Calculator.FinancingTerm' | translate }}*</b></label>
        <p>{{ 'Calculator.FinancingTermText' | translate }}</p>
     </div>
     <div class="form-group">
      <div class="month">
        <select class="form-control" formControlName="financingPeriod" [(ngModel)]="financingPeriod" required
          id="financingPeriod" name="financingPeriod" style="width: 214px; border-color: black; border-width: thin;">
          <option *ngFor="let period of [12, 24, 36, 48, 72]" [value]="period">{{ period }}</option>
        </select>
      </div>
     </div>
  </div>
  <div style="text-align: center;">
    <button type="submit" name="submit" [disabled]="!this.tableLoaded" (click)="getCalculator('payment')" class="mbfs-button">{{ 'Calculator.Calculate' | translate }}</button>
    <button type="submit" name="submit" (click)="clearCalculator()" class="mbfs-button">{{ 'Calculator.Clear' | translate }}</button>
    <br><br>
  </div>

  <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
    <!--Spinner on Login Load-->
    <div class="demo-container">
      <span>{{ 'Invoice.Loading' | translate }}</span>
      <div class="progress-bar">
        <div class="progress-bar-value"></div>
      </div>
    </div>
    <br>
  </div>

  <div class="shortrow" *ngIf="ShowMonthlyPayment">
    <div class="form-group">
      <label class ="inputlabel" for="first_name"><b style="color:#00566A;">{{ 'Calculator.ApproxMonthly' | translate }}</b></label>
   </div>
   <div class="form-group">
    <div class="dollar">
      <input  type="number" class="form-control" disabled validateonblur value="{{this.monthlyPayment}}"
      placeholder= " " id="monthlyPayment"  name="monthlyPayment" >
    </div>
   </div>
</div>
</form>
        </mat-expansion-panel>
      </mat-accordion>
      </div>
    </div>
    <br><br>
        <!--Copyright footer-->
        <footer id="mbfs-footer">
          <div role="contentinfo">
            <div class="mbfs-copyright">
              <p class="paragraph1"> {{ 'Calculator.Disclaimer' | translate }} </p>
            </div>
          </div>
        </footer>
        <section class='mbfs-red-banner-inner'>
          <div class="mbfs-red-banner-inner__box">
            <div class="mbfs-red-banner-inner__box--text">
              <h2 class="mbfs-red-banner-inner__header-title">
                {{'Calculator.Information' | translate }} 
                <a href="{{this.targetRedirect}}brochures">{{'Calculator.ClickHere' | translate }} </a>
                {{'FinanceLeaseSolutions.MoreInfo2' | translate }} <a href="{{this.targetRedirect}}dealerlocator"> {{
                  'Header.FindADealer' | translate }}</a>
              </h2>
            </div>
          </div>
        </section>
   </div>





